import { BpkCalendarGridHeader } from '@skyscanner-internal/backpack-web/bpk-component-calendar';

import type { DaysOfWeek } from '@skyscanner-internal/backpack-web/bpk-component-calendar';

import './CalendarGridHeader.scss';

type CalendarGridHeaderProps = {
  daysOfWeek: DaysOfWeek;
  firstDayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6;
};

const CalendarGridHeader = (props: CalendarGridHeaderProps) => (
  <BpkCalendarGridHeader
    {...props}
    weekDayKey="nameNarrow"
    className="month-view-calendar-grid-header"
  />
);

export default CalendarGridHeader;
